import { Phone, MapPin } from "lucide-react";
import { BUSINESS, SERVICES } from "@/lib/config";

export default function Footer() {
  return (
    <footer className="bg-zinc-950 text-zinc-400 pt-16 pb-8" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-12 gap-10 pb-10 border-b border-white/10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 bg-[#FF4500] flex items-center justify-center rounded-sm">
                <span className="text-white font-black text-lg">A</span>
              </div>
              <span className="text-white font-black text-lg">{BUSINESS.shortName}</span>
            </div>
            <p className="text-sm leading-relaxed max-w-sm">
              {BUSINESS.tagline}. 7/24 acil servis, garantili işçilik, şeffaf fiyatlandırma.
            </p>
            <div className="mt-6 flex items-center gap-2 text-zinc-300 text-sm">
              <MapPin className="w-4 h-4 text-[#FF4500] shrink-0 mt-0.5" />
              <span>{BUSINESS.shortAddress}</span>
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="text-white font-bold uppercase tracking-widest text-xs mb-4">Hizmetler</div>
            <ul className="space-y-2 text-sm">
              {SERVICES.slice(0, 6).map((s) => (
                <li key={s.id}>
                  <a href="#services" className="hover:text-[#FF4500]">{s.title}</a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-white font-bold uppercase tracking-widest text-xs mb-4">İletişim</div>
            <div className="space-y-3">
              <a href={`tel:${BUSINESS.phone1Tel}`} className="flex items-center gap-2 text-lg font-bold text-white hover:text-[#FF4500]" data-testid="footer-phone1">
                <Phone className="w-4 h-4" /> {BUSINESS.phone1}
              </a>
              <a href={`tel:${BUSINESS.phone2Tel}`} className="flex items-center gap-2 text-lg font-bold text-white hover:text-[#FF4500]" data-testid="footer-phone2">
                <Phone className="w-4 h-4" /> {BUSINESS.phone2}
              </a>
            </div>
          </div>
        </div>

        <div className="pt-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs">
          <div>© {new Date().getFullYear()} {BUSINESS.name}. Tüm hakları saklıdır.</div>
          <div className="flex items-center gap-4">
            <a href="/admin" className="hover:text-white" data-testid="footer-admin-link">Yönetici Girişi</a>
            <span className="text-zinc-700">·</span>
            <span>Diyarbakır / Kayapınar</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
